import React from "react";

const ConversationCard = ({
  id,
  name,
  created_at,
  onClickConversationCard,
}) => {
  return (
    <div
      className="cursor-pointer conversation-card"
      onClick={onClickConversationCard}
    >
      <p className=" fw-500 mb-4 nova-conversation-date">{created_at}</p>{" "}
      <h3 className="fs-small fw-600 ellipsis nova-conversation-title">
        {name}
      </h3>
    </div>
  );
};

export default ConversationCard;
